import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilService } from 'src/app/services/util-service/util.service';
import { GetListaService } from 'src/app/services/get-lista/get-lista.service';

@Injectable({ providedIn: 'root' })
export class CondicaoPagamentoResolve implements Resolve<Observable<any>>{

    constructor(private getListaService: GetListaService,
        private utilService: UtilService) { }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<Observable<any>> | Promise<Observable<any>> {
        return this.getListaService.getlista('SE4');
    }
}